var lists_default = {
  "fontElementMap": "vaNl0",
  "orderedlist": "_5acj-",
  "bulletedlist": "c7B7K",
  "listItem": "KQ7dT"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
